<template>
  <v-container fluid fill-height class="d-flex flex-column align-center justify-center">
    <h1
      v-t="'common.404'"
      class="text-h2 mb-6 primary500--text font-weight-bold"
    />
    <p v-t="'page.404.text'" class="mb-2 grey200--text" />
    <v-btn
      exact small text
      :to="{name: 'Home'}" :ripple="false"
    >
      <fai class="mr-2" icon="arrow-left" />
      <span v-t="'cta.back_home'" />
    </v-btn>
  </v-container>
</template>

<script>
// TODO add funny bg pic

export default {
  metaInfo() {
    return {
      title: this.$t('page.404.title'),
    }
  },
}
</script>
